(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/pay/assets/javascripts/account-services/player-deposit-suspended.js') >= 0) return;  svs.modules.push('/components/tur/pay/assets/javascripts/account-services/player-deposit-suspended.js');

'use strict';

const drawgamesApiCaller = svs.tur.apiCaller.drawgames;
const DEPOSITS_SUSPENDED = 'DEPOSITS_SUSPENDED';
const isPlayerDepositSuspendedAsync = async () => {
  try {
    const _await$drawgamesApiCa = await drawgamesApiCaller.getPlayerInfo({
        include: 'accountBalance,currentStatus'
      }),
      response = _await$drawgamesApiCa.response,
      status = _await$drawgamesApiCa.status;
    if (status && status === 'success') {
      var _response$currentStat;
      return (_response$currentStat = response.currentStatus) === null || _response$currentStat === void 0 ? void 0 : _response$currentStat.includes(DEPOSITS_SUSPENDED);
    }
    return false;
  } catch (error) {
    return false;
  }
};

async function playerDepositSuspended(_ref) {
  let next = _ref.next,
    cancel = _ref.cancel;
  const isDepositSuspended = await isPlayerDepositSuspendedAsync();
  if (isDepositSuspended) {
    svs.tur.apierrors.showErrorMessage({
      response: 5139,
      onConfirm: cancel
    });
  } else {
    next();
  }
}
svs.tur.pay.account_services.playerDepositSuspended = playerDepositSuspended;

 })(window);